import { Observable  } from 'rxjs'

export class EventEmitterWithValueReturned<T> {
    ReturnValue: T;
}


export class EventEmitterWithObservable extends EventEmitterWithValueReturned<Observable<any>> {
}
